import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-iconPark-classroom",
  "use": "icon-iconPark-classroom-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-iconPark-classroom\"><rect width=\"48\" height=\"48\" fill=\"white\" fill-opacity=\"0.01\" /><circle cx=\"24\" cy=\"13\" r=\"9\" fill=\"none\" stroke=\"#333\" stroke-width=\"4\" stroke-linejoin=\"round\" /><path d=\"M5 44C5 35.5625 11.175 27.6875 16.4 26C16.4 26 21.15 31.0625 24 34.4375L31.6 26C35.875 26.5625 43 35.5625 43 44\" stroke=\"#333\" stroke-width=\"4\" stroke-linejoin=\"round\" /><path d=\"M2 44L46 44\" stroke=\"#333\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/iconPark-classroom.svg
// module id = jFPi
// module chunks = 24